import React from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import LeaderboardRankCard from "components/LeaderboardRankCard";
import { loadStandings } from "modules/playground/action";
import { getStandings } from "modules/playground/selectors";
import { isLoggedIn } from "modules/session/selectors";

const Back = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 1em;

  p {
    font-size: 18px;
    padding-left: 1em;
    font-weight: bold;
    margin-top: 0px;
    color: white;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 32px;
`;

const Final = styled.h2`
  font-family: "Gilroy";
  text-align: center;
  margin: 8px 0;
`;

function LeaderboardPage(props) {
  React.useState(() => {
    if (props.isLoggedIn) {
      props.loadStandings();
    }
  }, []);

  const standings = props.standings ? props.standings : [];

  return (
    <Link to="/play" style={{ color: "white" }}>
      <Back>
        <svg
          width="15"
          height="26"
          viewBox="0 0 15 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.9932 1.47998L2.48001 12.9886L12.9895 24.4581"
            stroke="white"
            stroke-width="2"
          />
        </svg>
        <p>Leaderboard</p>
      </Back>
      <Final>FINAL STANDING</Final>
      <Container>
        {standings.map((items, index) => (
          <LeaderboardRankCard
            key={index + items.account.name}
            rank={index + 1}
            playerName={items.account.name}
            point={items.points_earned}
            team={items.play_id[0]}
          />
        ))}
      </Container>
    </Link>
  );
}

const withConnect = connect(
  state => ({
    standings: getStandings(state),
    isLoggedIn: isLoggedIn(state),
  }),
  { loadStandings }
);

export default withConnect(LeaderboardPage);
